import type { AxiosInstance } from 'axios';
import { useCacheStore } from '@/stores/cache/useCacheStore';
import { HTTP_MULTIPLE_CHOICES, HTTP_OK } from '@/helpers/httpStatusCodes';

export default (http: AxiosInstance) => {
    const cacheStore = useCacheStore();
    http.interceptors.request.use((config) => {
        if (config.cache) {
            const { key, swr } = config.cache;

            if (swr) {
                return config;
            }
            const cache = cacheStore.get({ key });
            if (cache) {
                return Promise.reject({
                    config,
                    response: {
                        data: cache
                    }
                });
            }
            else {
                return config;
            }
        }
        return config;
    }, (err) => {
        console.log(err);
        return Promise.reject(err);
    });
    http.interceptors.response.use(function (response) {
        if (response.config?.cache) {
            const { key } = response.config.cache;

            if (response.status && response.status >= HTTP_OK && response.status < HTTP_MULTIPLE_CHOICES) {
                cacheStore.set({ key, data: response.data });
            }
        }
        return response;
    }, (err) => {
        if (err.response?.cache) {
            return Promise.resolve(err.response);
        }
        return Promise.reject(err);
    });
};
